import type { ReactElement } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './auth/AuthContext.js';
import { WidgetEmbedder } from './components/WidgetEmbedder.js';
import { OrgScopeProvider } from './org/OrgScopeContext.js';
import { AppRoutes } from './routes/index.js';
import { ThemeProvider } from './theme/ThemeProvider.js';

/**
 * Dashboard root.
 *
 * Composes the provider stack and the router:
 *   ThemeProvider (dark/light) → BrowserRouter → AuthProvider (session) →
 *   OrgScopeProvider (active org) → AppRoutes (login + role-gated areas).
 *
 * `WidgetEmbedder` sits inside the router but above AuthProvider so the dogfooded
 * feedback widget mounts on EVERY route, including the pre-auth login page.
 *
 * All data flows through `@hotline/client-core`; this app never touches the DB.
 */
export default function App(): ReactElement {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <WidgetEmbedder />
        <AuthProvider>
          <OrgScopeProvider>
            <AppRoutes />
          </OrgScopeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
